module.exports = __webpack_public_path__ + "static/media/item_2_3.bcd014b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_3.png
// module id = 110
// module chunks = 0